import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.5 36.1667V23.1667C14.5 20.7734 12.5599 18.8333 10.1667 18.8333H5.83333C3.4401 18.8333 1.5 20.7734 1.5 23.1667V36.1667C1.5 38.5599 3.4401 40.5 5.83333 40.5H10.1667C12.5599 40.5 14.5 38.5599 14.5 36.1667ZM14.5 36.1667V14.5C14.5 12.1068 16.4401 10.1667 18.8333 10.1667H23.1667C25.5599 10.1667 27.5 12.1068 27.5 14.5V36.1667M14.5 36.1667C14.5 38.5599 16.4401 40.5 18.8333 40.5H23.1667C25.5599 40.5 27.5 38.5599 27.5 36.1667M27.5 36.1667V5.83333C27.5 3.4401 29.4401 1.5 31.8333 1.5H36.1667C38.5599 1.5 40.5 3.4401 40.5 5.83333V36.1667C40.5 38.5599 38.5599 40.5 36.1667 40.5H31.8333C29.4401 40.5 27.5 38.5599 27.5 36.1667Z",
      stroke: "currentColor",
      "stroke-width": "3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }